module.exports = __webpack_public_path__ + "img/book-module-audio-info.0dce20a8.png";